import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true, // Important pour les cookies/sessions
  headers: {
    "Content-Type": "application/json",
  },
});

// Products
export const getProducts = () => api.get("/products");
export const getProduct = (id) => api.get(`/products/${id}`);
export const getFeaturedProducts = () => api.get("/products?featured=true");

// Orders
export const createOrder = (orderData) => api.post("/orders", orderData);
export const getOrder = (id) => api.get(`/orders/${id}`);
export const getOrderByNumber = (orderNumber) =>
  api.get(`/orders/number/${orderNumber}`);

// Payment
export const createCheckoutSession = (data) =>
  api.post("/payment/create-checkout-session", data);
export const verifySession = (sessionId) =>
  api.post("/payment/verify-session", { sessionId });

// Auth
export const register = (userData) => api.post("/users/register", userData);
export const login = (credentials) => api.post("/users/login", credentials);

// Countries
export const getCountries = () => api.get("/countries");
export const calculateShipping = (data) => api.post("/countries/calculate-shipping", data);

// Settings
export const getSettings = () => api.get("/settings");

// Images
export const getImageUrl = (imageType) => {
  const baseUrl = process.env.REACT_APP_API_URL || "http://localhost:5000/api";
  return `${baseUrl}/images/${imageType}?t=${Date.now()}`;
};

export const getImageInfo = (imageType) => api.get(`/images/info/${imageType}`);

// Videos
export const getVideoUrl = (videoType, download = false) => {
  const baseUrl = process.env.REACT_APP_API_URL || "http://localhost:5000/api";
  return `${baseUrl}/videos/${videoType}${download ? "?download=true" : ""}`;
};

export const getVideoInfo = (videoType) => api.get(`/videos/info/${videoType}`);
export const getInstagramUrl = () => api.get("/videos/settings/instagram-url");

// Product Images
export const getProductImageUrl = (imageId) => {
  const baseUrl = process.env.REACT_APP_API_URL || "http://localhost:5000/api";
  return `${baseUrl}/product-images/${imageId}`;
};

export default api;
